import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { SoundProvider } from './lib/sound';
import { RegistrationPage } from './pages/RegistrationPage';

const LookupPage = lazy(async () => ({ default: (await import('./pages/LookupPage')).LookupPage }));
const AdminPage = lazy(async () => ({ default: (await import('./pages/AdminPage')).AdminPage }));
const CheckinPage = lazy(async () => ({ default: (await import('./pages/CheckinPage')).CheckinPage }));
const QuickRegistrationPage = lazy(async () => ({ default: (await import('./pages/QuickRegistrationPage')).QuickRegistrationPage }));
const CommunityRedirectPage = lazy(async () => ({ default: (await import('./pages/CommunityRedirectPage')).CommunityRedirectPage }));

function RouteLoading(): JSX.Element {
  return <main className="route-loading" aria-live="polite"><span className="spinner" /> Carregando ambiente…</main>;
}

function ConsultationRoute(): JSX.Element {
  const [searchParams] = useSearchParams();
  if (searchParams.get('destino') === 'sunju_comunidade') return <Suspense fallback={<RouteLoading />}><CommunityRedirectPage /></Suspense>;
  return <Suspense fallback={<RouteLoading />}><LookupPage /></Suspense>;
}

export function App(): JSX.Element {
  return (
    <SoundProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RegistrationPage />} />
          <Route path="/inscricao" element={<RegistrationPage />} />
          <Route path="/consultar" element={<ConsultationRoute />} />
          <Route path="/colaborador" element={<RegistrationPage type="collaborator" />} />
          <Route path="/admin" element={<Suspense fallback={<RouteLoading />}><AdminPage /></Suspense>} />
          <Route path="/checkin" element={<Suspense fallback={<RouteLoading />}><CheckinPage /></Suspense>} />
          <Route path="/inscricao-rapida" element={<Suspense fallback={<RouteLoading />}><QuickRegistrationPage /></Suspense>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </SoundProvider>
  );
}
